export default {
  actions: {
    RECEIVE_TOKEN: 'RECEIVE_TOKEN',
  },
};
